<template>
  <div class="product-info">
    <h2 id="productTitle">{{ product.title }}</h2>
    <span v-html="product.intro" />

    <product-tariffs v-if="product.__typename === 'RegularProduct'"
                     :product="product"
                     :configurations="configurations"
                     :customer-groups-to-show="customerGroupsToShow"
                     :terms="terms"
                     :selected-customer-group="customerGroup"
                     :date-effective="dateEffective"
                     @selectCustomerGroup="onSelectCustomerGroup"/>

    <product-description :description="product.description"/>
  </div>
</template>

<script>
import ProductDescription from './Description'
import ProductTariffs from './Tariffs'
import { CustomerGroup } from '../../types/filter-entity/customer-group'
import { DateString } from '../../types/date-string'

export default {
  components: {
    ProductDescription,
    ProductTariffs
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    configurations: {
      type: Array,
      required: true
    },
    customerGroupsToShow: {
      type: Array,
      required: true
    },
    terms: {
      type: Array,
      required: true
    },
    customerGroup: {
      type: CustomerGroup,
      required: true
    },
    dateEffective: {
      type: DateString,
      default: null
    }
  },
  methods: {
    onSelectCustomerGroup: function (customerGroup) {
      this.$emit('selectCustomerGroup', customerGroup)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product-detail/Info.vue